"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Merging children in the provided parent node.
 */
function mergeDomChildren(dom, newChildNodes) {
    var nodesArray = Array.prototype.slice.call(dom.childNodes || []);
    nodesArray.forEach(function (n) {
        if (newChildNodes.indexOf(n) < 0) {
            dom.removeChild(n);
        }
    });
    newChildNodes.forEach(function (n, i) {
        if (dom.childNodes[i] !== n) {
            if (i < dom.childNodes.length) {
                dom.insertBefore(n, dom.childNodes[i]);
            }
            else {
                dom.appendChild(n);
            }
        }
    });
}
exports.mergeDomChildren = mergeDomChildren;
